import {
	GET_PRODUCTS_SUCCESS,
	GET_PRODUCTS_FAIL,
	GET_PRODUCT_SUCCESS,
	GET_PRODUCT_FAIL,
	SEARCH_PRODUCTS_SUCCESS,
	SEARCH_PRODUCTS_FAIL,
	RELATED_PRODUCTS_SUCCESS,
	RELATED_PRODUCTS_FAIL,
	FILTER_PRODUCTS_SUCCESS,
	FILTER_PRODUCTS_FAIL,
	HIGHLIGHT_PRODUCTS_SUCCESS,
	HIGHLIGHT_PRODUCTS_FAIL,
	GET_PROMOS_SUCCESS,
	GET_PROMOS_FAIL,
} from './types'
import axios from 'axios'


export const get_products = (filters = {}, sort = {}, page={}) => async dispatch => {
    const config = {
        headers: {
            'Accept': 'application/json'
        }
    };

    let queryParams = [];

    if (filters.type && filters.type !== "all") queryParams.push(`type=${filters.type}`);
    if (filters.category) queryParams.push(`category=${filters.category}`);
    if (filters.price_min) queryParams.push(`price_min=${filters.price_min}`);
    if (filters.price_max) queryParams.push(`price_max=${filters.price_max}`);
    if (filters.rating_min) queryParams.push(`rating_min=${filters.rating_min}`);
    if (filters.rating_max) queryParams.push(`rating_max=${filters.rating_max}`);
    if (filters.material) queryParams.push(`material=${filters.material}`);
    if (filters.discount) queryParams.push(`discount=${filters.discount}`);
    if (sort.sortBy) queryParams.push(`sortBy=${sort.sortBy}`);
    if (sort.order) queryParams.push(`order=${sort.order}`);
    if (page) queryParams.push(`page=${page}`);

    const queryString = queryParams.length > 0 ? '?' + queryParams.join('&') : '';

    try {
        const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/product/get-products/${queryString}`, config);

        if (res.status === 200) {
            dispatch({
                type: GET_PRODUCTS_SUCCESS,
                payload: res.data
            });
        } else {
            dispatch({
                type: GET_PRODUCTS_FAIL
            });
        }
    } catch(err) {
        dispatch({
            type: GET_PRODUCTS_FAIL
        });
    }
};

export const get_product = (productId) => async dispatch => {
	const config = {
		headers: {
			'Accept': 'application/json'
		}
	};

	try {
		const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/product/product/${productId}`, config);
	
		if (res.status === 200) {
			dispatch({
				type: GET_PRODUCT_SUCCESS,
				payload: res.data
			});
		} else {
			dispatch({
				type: GET_PRODUCT_FAIL
			});
		}
	} catch(err) {
		dispatch({
			type: GET_PRODUCT_FAIL
		});
	}
};

export const get_related_products = (productId) => async dispatch => {
	const config = {
		headers: {
			'Accept': 'application/json'
		}
	};

	try {
		const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/product/related/${productId}`, config);
	
		if (res.status === 200) {
			dispatch({
				type: RELATED_PRODUCTS_SUCCESS,
				payload: res.data
			});
		} else {
			dispatch({
				type: RELATED_PRODUCTS_FAIL
			});
		}
	} catch(err) {
		dispatch({
			type: RELATED_PRODUCTS_FAIL
		});
	}
};

export const get_search_products = (search, page = 1) => async dispatch => {
	const config = {
		headers: {
			'Accept': 'application/json',
			'Content-Type': 'application/json'
		}
	};

	const body = JSON.stringify({
		search
	});

	try {
		const res = await axios.post(`${process.env.REACT_APP_API_URL}/api/product/search/?page=${page}`, body, config);

		if (res.status === 200) {
			dispatch({
				type: SEARCH_PRODUCTS_SUCCESS,
				payload: res.data
			});
		} else {
			dispatch({
				type: SEARCH_PRODUCTS_FAIL
			});
		}
	} catch(err) {
		dispatch({
			type: SEARCH_PRODUCTS_FAIL
		});
	}
};

export const get_highlighted_products = () => async dispatch => {
	const config = {
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    };

    try {
        const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/product/highlighted`, config);
	
		if (res.status === 200 && !res.data.error) {
            dispatch({
                type: HIGHLIGHT_PRODUCTS_SUCCESS,
                payload: res.data
            });
        } else {
            dispatch({
                type: HIGHLIGHT_PRODUCTS_FAIL
            });
        }
    } catch (err) {
        dispatch({
            type: HIGHLIGHT_PRODUCTS_FAIL
        });
    }
}

export const get_promo = () => async dispatch => {
	const config = {
		headers: {
			'Accept': 'application/json'
		}
	};

	try {
		const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/product/promo`, config);

		if (res.status === 200) {
			dispatch({
				type: GET_PROMOS_SUCCESS,
				payload: res.data
			});
		} else {
			dispatch({
				type: GET_PROMOS_FAIL
			});
		}
	} catch(err) {
		dispatch({
			type: GET_PROMOS_FAIL
		});
	}
};